/**
 * @generated SignedSource<<21354aa5e2cd078e627903ce8cef4c0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContractRequestStatusEnum = "completed" | "pending" | "rejected" | "started";
export type CreateAnswerInput = {
  clientMutationId?: string | null | undefined;
  questionId: string;
  textualAnswer: string;
};
export type AnswerListItem_CreateAnswerMutation$variables = {
  input: CreateAnswerInput;
};
export type AnswerListItem_CreateAnswerMutation$data = {
  readonly createAnswer: {
    readonly answer: {
      readonly contractRequests: ReadonlyArray<{
        readonly status: ContractRequestStatusEnum | null | undefined;
      }> | null | undefined;
      readonly id: string;
      readonly question: {
        readonly id: string;
        readonly textualAnswer: {
          readonly contractRequests: ReadonlyArray<{
            readonly status: ContractRequestStatusEnum | null | undefined;
          }> | null | undefined;
          readonly id: string;
          readonly rawId: number | null | undefined;
          readonly textualAnswer: string | null | undefined;
        } | null | undefined;
        readonly title: string;
      } | null | undefined;
      readonly rawId: number | null | undefined;
      readonly textualAnswer: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AnswerListItem_CreateAnswerMutation = {
  response: AnswerListItem_CreateAnswerMutation$data;
  variables: AnswerListItem_CreateAnswerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textualAnswer",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractRequest",
  "kind": "LinkedField",
  "name": "contractRequests",
  "plural": true,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractRequest",
  "kind": "LinkedField",
  "name": "contractRequests",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnswerListItem_CreateAnswerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAnswerPayload",
        "kind": "LinkedField",
        "name": "createAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Answer",
            "kind": "LinkedField",
            "name": "answer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "kind": "LinkedField",
                    "name": "textualAnswer",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnswerListItem_CreateAnswerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAnswerPayload",
        "kind": "LinkedField",
        "name": "createAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Answer",
            "kind": "LinkedField",
            "name": "answer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "kind": "LinkedField",
                    "name": "textualAnswer",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0603e0b7d5128ec2ddec744b897a8c49",
    "id": null,
    "metadata": {},
    "name": "AnswerListItem_CreateAnswerMutation",
    "operationKind": "mutation",
    "text": "mutation AnswerListItem_CreateAnswerMutation(\n  $input: CreateAnswerInput!\n) {\n  createAnswer(input: $input) {\n    answer {\n      id\n      rawId\n      textualAnswer\n      question {\n        id\n        title\n        textualAnswer {\n          id\n          rawId\n          textualAnswer\n          contractRequests {\n            status\n            id\n          }\n        }\n      }\n      contractRequests {\n        status\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f206a9dabfed00ae935af1de5166625f";

export default node;
